<template>
  <base-modal modal-id="check-email-modal">
    <template v-slot:header>
      <h4 class="modal-title mb-0">{{_T('Just Checking')}}</h4>
    </template>
    <template v-slot:modal-body>
      <div class="check-email">
        <h6>{{_T('This is your email address:')}}</h6>
        <h6>{{_T('bimbimasli13@gmail.com')}}</h6>
        <div class="btns">
          <button
            type="button"
            class="btn btn-outline"
            @click="$bvModal.hide('check-email-modal')"
          >
            {{_T('No')}}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="$bvModal.hide('check-email-modal')"
          >
            {{_T('Yes')}}
          </button>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import {mapGetters} from "vuex"
import BaseModal from '../BaseModal'
export default {
  name: 'VerifyEmail',
  components: {
    BaseModal,
  },
   computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
  .body-rtl {
    .edit-profile {
      .modal-body {
        .btns {
          text-align: left;
          .btn {
            + .btn {
              margin-right: $px8;
              margin-left: unset;
            }
          }
        }

        label {
          text-align: right;
          float: right;
        }
      }
    }
  }
</style>
